import type { TimeValue } from '@/components/ui/time-picker'
import type { Claim, ClaimTowVehicle, ClaimWhatDamaged, ClaimWhatHappened } from '../../../../models/claim'
import { parseTimeValue } from './claimFormValues'

/** Step 3 (Incident Details) form state — the single source of truth (react-hook-form). */
export interface Step3FormValues {
  // When & where
  date: Date | null
  time: TimeValue | null
  city: string
  state: string
  location: string
  // What happened
  whatHappened: ClaimWhatHappened[]
  howManyVehicles: string
  whatDamaged: ClaimWhatDamaged[]
  briefDescription: string
  // Cargo & broker
  cargoOnBoard: boolean | null
  freightBrokerName: string
  freightBrokerContact: string
  // Vehicle & load status
  truckDriveable: string
  vehiclesNeedingTow: ClaimTowVehicle[]
  loadStatus: string
  // Notes
  anythingElse: string
}

export const STEP3_DEFAULTS: Step3FormValues = {
  date: null,
  time: null,
  city: '',
  state: '',
  location: '',
  whatHappened: [],
  howManyVehicles: '',
  whatDamaged: [],
  briefDescription: '',
  cargoOnBoard: null,
  freightBrokerName: '',
  freightBrokerContact: '',
  truckDriveable: '',
  vehiclesNeedingTow: [],
  loadStatus: '',
  anythingElse: '',
}

/** Build Step 3 defaults from an existing claim (edit mode + Step 1 prefill of date/time/city). */
export function claimToStep3Defaults(claim: Claim): Step3FormValues {
  const i = claim.incident
  if (!i) return STEP3_DEFAULTS
  return {
    date: i.date ? new Date(`${i.date}T00:00:00`) : null,
    time: parseTimeValue(i.time),
    city: i.city,
    state: i.state,
    location: i.locationDescription,
    whatHappened: i.whatHappened ?? [],
    howManyVehicles: i.howManyVehicles,
    whatDamaged: i.whatDamaged ?? [],
    briefDescription: i.briefDescription,
    cargoOnBoard: i.cargoOnBoard,
    freightBrokerName: i.freightBrokerName,
    freightBrokerContact: i.freightBrokerContact,
    truckDriveable: i.truckDriveable,
    vehiclesNeedingTow: i.vehiclesNeedingTow ?? [],
    loadStatus: i.loadStatus,
    anythingElse: i.anythingElse,
  }
}

/** Fields an upload read fills together or not at all, so a city never lands in another state. */
export const STEP3_GROUPS: (keyof Step3FormValues)[][] = [
  ['date', 'time'],
  ['city', 'state', 'location'],
  ['freightBrokerName', 'freightBrokerContact'],
]
